import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CalendarOutlined,
  DashboardOutlined,
  FileTextOutlined,
  TableOutlined,
} from "@ant-design/icons";
import TabSelection from "../../components/SelectContent/TabSelection";
import { setPrismTab } from "../../state/slices/generalSlice";
import PrismCalendar from "./PrismCalendar";
import PrismDashboard from "./PrismDashboard";
import PrismReports from "./PrismReports";
import PrismSubscriptions from "./PrismSubscriptions";
import { canManageAnyPrismOffice } from "./prismSubscriptionUtils";

const regularMenuItems = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: <DashboardOutlined />,
    component: <PrismDashboard />,
    layoutClassName: "tab-selection-container--dashboard",
  },
  {
    key: "subscriptions",
    label: "Subscriptions",
    icon: <TableOutlined />,
    component: <PrismSubscriptions />,
  },
];

const managerMenuItems = [
  ...regularMenuItems,
  {
    key: "calendar",
    label: "Calendar",
    icon: <CalendarOutlined />,
    component: <PrismCalendar />,
    layoutClassName: "tab-selection-container--calendar",
  },
  {
    key: "reports",
    label: "Reports",
    icon: <FileTextOutlined />,
    component: <PrismReports />,
  },
];

const PrismPage = () => {
  const dispatch = useDispatch();
  const { details = {} } = useSelector((state) => state.accountDetailSlice);
  const currentTab = useSelector(
    (state) => state.generalSlice.prismCurrentTab,
  );
  const rolesLoaded = Array.isArray(details.admin_roles);
  const canAccessPrivilegedTabs = useMemo(
    () => canManageAnyPrismOffice(details),
    [details],
  );
  const menuItems = canAccessPrivilegedTabs
    ? managerMenuItems
    : regularMenuItems;

  useEffect(() => {
    if (
      rolesLoaded &&
      !menuItems.some((item) => item.key === currentTab)
    ) {
      dispatch(setPrismTab("dashboard"));
    }
  }, [currentTab, dispatch, menuItems, rolesLoaded]);

  return (
    <TabSelection
      menuItems={menuItems}
      currentTabKey="prismCurrentTab"
      setTabAction={setPrismTab}
    />
  );
};

export default PrismPage;
